<script>
  import { onMount } from "svelte";
  import MarketingLimitsWarning from "../Common/MarketingLimitsWarning.svelte";

  import { parseNumber } from "../Common/tools";
  import Table from "../Table/Table.svelte";
  import {External, M} from "../external";
  import { createCampaign } from "../CampaignLists/Index.svelte";

  export let data;

  let needsToConnectDomain = false;
  let showLimitsIncreaseButton = false;
  let helpVideoMarkup = "";

  let getSign = (value) => {
    if (value > 0) {
      return "+";
    }
    return "";
  };

  let onClick = (row) => {
    let url = (row.messageCampaign ? "/me/crm/marketing/campaign/message/overview?id=" : "/me/crm/marketing/campaign/overview?id=") + row.id;
    External.CPanel.goToUrl(url, true);
  };

  onMount(() => {
    showLimitsIncreaseButton = External.Website.hasPermission(External.Permission.BILLING);
    needsToConnectDomain = !(External.Website.emailMarketingSettings && External.Website.emailMarketingSettings.domains && External.Website.emailMarketingSettings.domains.length);
    if (External.Website.onboarding && External.Website.onboarding.marketingDashboard) helpVideoMarkup = External.CPanel.getEmbedVideo(External.Website.onboarding.marketingDashboard);
  });
</script>

<div class="sections-wrapper members-wrapper">
  <div class="flex col20 f-left flex-col box-shadow" style="margin-top: -40px; background: #fff;">
    <!--
        <div class="flex col20 f-left">
            <div class="analytics-box">
                <h3>Subscribers</h3>
                <h2 class="col20 f-left f-28 gray-text"><b>{parseNumber(data.subscribers)}</b></h2>
            </div>
            <div class="analytics-box">
                <h3>Subscribers This Month</h3>
                <h2 class="col20 f-left f-28 gray-text"><b>{parseNumber(data.subscribersMonth)} <span
                        class="increase">{getSign(data.subscribersMonthPercent)}{parsePercent(data.subscribersMonthPercent)}
                    <span
                            class="material-icons"> arrow_upward </span></span></b></h2>
            </div>
            <div class="analytics-box">
                <h3>Earnings This Month</h3>
                <h2 class="col20 f-left f-28 gray-text"><b>{parseCurrency(data.earningsMonth, '$')} <span
                        class="increase">{getSign(data.earningsMonthPercent)}{parsePercent(data.earningsMonthPercent)}
                    <span
                            class="material-icons"> arrow_upward </span></span></b></h2>
            </div>
        </div>
        -->
    <div class="mt-25 col20 f-left email-dashboard-wrapper">
      <div class="flex flex-col-tablet">
        <div class="col13 flex-col f-left flex-none mr-5p">
          {#if data.campaigns && data.campaigns.rows.length > 0}
            <div class="flex align-center space-between col20 mb-25">
              <h2 class="f-left f-28 gray-text flex-none">{M.LAST_SENT_CAMPAIGNS}</h2>
              <a class="blue middle-button with-icon" on:click={createCampaign}>{M.CREATE_CAMPAIGN}</a>
            </div>
            <Table data={data.campaigns.rows} activeColumns={data.campaigns.columns} hasSelection={false} onClick={onClick} />
          {:else}
            <div class="col20 f-left getting-started-layout getting-started-layout-middle flex">
              <div class="col20 f-left">
                {#if helpVideoMarkup}
                  <div class="col20 f-left mb-25">
                    {@html helpVideoMarkup}
                  </div>
                {/if}
                <h4 class="col20 f-left"><span>{M.EMAIL_CAMPAIGNS}</span></h4>
                <h3 class="col20 f-left mt-10 mb-15">{M.EMAIL_CAMPAIGNS_TITLE}</h3>
                <span class="col20 f-left paragraph-text mb-15">{M.EMAIL_CAMPAIGNS_DESCRIPTION}</span>
                <div class="col20 f-left">
                  <a on:click={createCampaign} class="blue big-button with-icon">{M.START_A_CAMPAIGN}</a>
                </div>
              </div>
            </div>
          {/if}
        </div>
        <div class="col6 f-right side-analytics-box getting-started-layout getting-started-layout-middle flex-none">
          <h2 class="col20 f-left f-28 gray-text mb-25">{M.STATISTICS}</h2>
          <h3>{M.SUBSCRIBERS}</h3>
          <h2 class="col20 f-left f-28 gray-text"><b>{parseNumber(data.subscribers)} </b></h2>

          <h3 class="mt-25">{M.SUBSCRIBERS_THIS_MONTH}</h3>
          <h2 class="col20 f-left f-28 gray-text">
            <b>
              {parseNumber(data.subscribers - data.subscribersPreviousMonth)}
              <span class:increase={data.subscribersIncrease > 0} class:decrease={data.subscribersIncrease < 0}>
                {#if data.subscribersIncrease != 0}
                  {data.subscribersIncrease > 0 ? "+" : "-"}
                  {data.subscribersIncrease}%
                  <span class="material-icons"> {data.subscribersIncrease > 0 ? "arrow_upward" : "arrow_downward"} </span>
                {/if}
              </span>
            </b>
          </h2>
          <h3 class="mt-25">{M.TOTAL_EMAILS_SENT}</h3>
          <h2 class="col20 f-left f-28 gray-text">
            <b>
              {parseNumber(data.sentEmails)}
            </b>
          </h2>
          {#if showLimitsIncreaseButton}
            <div class="col20 f-left mt-35"><a rel="tab" href="/me/settings/billing" class="middle-button blue">{M.INCREASE_LIMITS}</a></div>
          {/if}
          <!--
                    <h3 class="mt-25">Earnings This Month</h3>
                    <h2 class="col20 f-left f-28 gray-text"><b>{parseCurrency(data.earningsMonth, '$')} <span
                            class="increase">{getSign(data.earningsMonthPercent)}{parsePercent(data.earningsMonthPercent)}
                        <span
                                class="material-icons"> arrow_upward </span></span></b></h2>
                            -->
          <!--
                    <div class="analytics-box analytics-call-to-action">
                        <h2 class="col20 f-left f-28">Quick Actions</h2>
                        <ul class="col20 f-left mt-35 analytics-actions">
                            <li><a on:click={() => CPanel.goToUrl('/me/crm/marketing/campaign', true)}><span
                                    class="material-icons-outlined"> email </span>Create A Campaign</a></li>
                            <li><a on:click={() => CPanel.goToUrl('/me/crm/marketing/lists', true)}><span
                                    class="material-icons-outlined"> supervisor_account </span>Add Contacts</a>
                            </li>
                            <li><a on:click={() => CPanel.goToUrl('/me/crm/marketing/lists', true)}><span
                                    class="material-icons-outlined"> dvr </span>Create A List</a></li>
                            <li><a on:click={() => CPanel.goToUrl('/me/crm/marketing/automations', true)}><span
                                    class="material-icons-outlined"> autorenew </span>Start An Automation</a>
                            </li>
                        </ul>
                    </div>
                -->
        </div>
      </div>

      <MarketingLimitsWarning customClass="mt-35" />

      {#if needsToConnectDomain}
        <div class="col20 f-left getting-started-layout getting-started-layout-middle higlighted-box flex" style="margin-top: 5%;">
          <div class="col20 f-left">
            <h3 class="col20 f-left mb-15">{M.CONNECT_DOMAIN}</h3>
            <span class="col20 f-left paragraph-text mb-25">{M.CONNECT_DOMAIN_DESC}</span>
            <div class="col20 f-left">
              <a on:click={() => External.CPanel.goToUrl("/me/crm/marketing/settings", true)} class="middle-button rounded-effect">{M.CONNECT_DOMAIN}</a>
            </div>
          </div>
        </div>
      {/if}
    </div>
    <div class="col20 f-left flex email-dashboard-boxes mb-35 flex-col-tablet">
      <div class="f-left getting-started-layout getting-started-layout-small flex">
        <div class="col20 f-left">
          <span class="material-icons-outlined icon"> group_add </span>
          <h1 class="col20 f-left mt-10 mb-15">{M.ADD_SUBSCRIBERS}</h1>
          <span class="col20 f-left paragraph-text mb-25">{M.ADD_SUBSCRIBERS_DESC}</span>
          <div class="col20 f-left">
            <a on:click={() => External.CPanel.goToUrl("/me/crm/marketing/lists", true)} class="blue big-button with-icon">{M.ADD_SUBSCRIBERS}</a>
          </div>
        </div>
      </div>
      <div class="f-left getting-started-layout getting-started-layout-small flex">
        <div class="col20 f-left">
          <span class="material-icons-outlined icon"> dvr </span>
          <h1 class="col20 f-left mt-10 mb-15">{M.CREATE_SUBSCRIBER_LISTS}</h1>
          <span class="col20 f-left paragraph-text mb-25">{M.CREATE_SUBSCRIBER_LISTS_DESC}</span>
          <div class="col20 f-left">
            <a on:click={() => External.CPanel.goToUrl("/me/crm/marketing/lists", true)} class="blue big-button with-icon">{M.CREATE_LISTS}</a>
          </div>
        </div>
      </div>
      <div class="f-left getting-started-layout getting-started-layout-small flex">
        <div class="col20 f-left">
          <span class="material-icons-outlined icon"> autorenew </span>
          <h1 class="col20 f-left mt-10 mb-15">{M.CREATE_AUTOMATION_FLOWS}</h1>
          <span class="col20 f-left paragraph-text mb-25">{M.CREATE_AUTOMATION_FLOWS_DESC}</span>
          <div class="col20 f-left">
            <a on:click={() => External.CPanel.goToUrl("/me/crm/marketing/automations", true)} class="blue big-button with-icon">{M.START_AUTOMATION}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
